import React, { useEffect, useState } from "react";
import {
  getCorpDartNewsesAPI,
  getDartNewsAPI,
  getSingleNewsCurateAPI,
} from "../../apis/news_service";
import thumbnail from "../../assets/images/thumbnail_default.jpg";
import thumbnail2 from "../../assets/images/thumbnail_default2.png";
import thumbnail3 from "../../assets/images/thumbnail_default3.png";
import thumbnail4 from "../../assets/images/thumbnail_default4.png";
import thumbnail5 from "../../assets/images/thumbnail_default5.png";
import styles from "../../assets/styles/modules/Newsinfo.module.css";
import { Button, Checkbox, Fade, Paper, Popper } from "@mui/material";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import toast, { Toaster } from "react-hot-toast";
import IosShareIcon from "@mui/icons-material/IosShare";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import mail from "../../assets/images/ico_mail_color.png";
import kakao from "../../assets/images/ico_kakao_color.png";
import { pasteURL } from "../../apis/toast_message";
import {
  addMycorpAPI,
  addScrapAPI,
  checkMycorpAPI,
  checkScrapAPI,
  deleteScrapNewsAPI,
  delMycorpAPI,
} from "../../apis/my_service";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Obscure } from "../../components/common/\bobscuredImage";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const RelatedNews = ({ title, src }) => {
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <p
        style={{
          fontSize: "15px",
          color: "#222",
          marginRight: "12px",
          lineHeight: "1.2",
        }}
      >
        {title}
      </p>
      <Obscure>
        <img src={src} alt="썸네일" width={95} />
      </Obscure>
    </div>
  );
};
const DartSingleNews = () => {
  const navigate = useNavigate();
  const pathname = window.location.pathname.split("/");
  const [newsId, setNewsId] = useState(pathname[pathname.length - 1]);
  const [news, setNews] = useState(null); // 공시 뉴스 데이터
  const [curate, setCurate] = useState(""); // 종목 큐레이팅 msg
  const [stockcode, setStockcode] = useState("");
  const [corpDartNewsList, setCorpDartNewsList] = useState(""); //기업의 공시뉴스 리스트

  const [scrap, setScrap] = useState(null); // 북마크 여부
  const [scrapIdx, setScrapIdx] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false); // 공유 모달창 오픈;
  const [subject, setSubject] = useState(""); // 이메일 제목
  const [mailBody, setMailBody] = useState(""); // 이메일 내용
  const [isSubscribe, setIsSubscribe] = useState(null);

  const getNewsData = () => {
    getDartNewsAPI(newsId)
      .then((res) => {
        setNews(res[0]);
        setStockcode(res[0].stockcode);
        return res[0];
      })
      .then((res) => {
        getCorpDartNewsesAPI(res.stockcode).then((res) =>
          setCorpDartNewsList(res)
        );
        getSingleNewsCurateAPI(res.stockcode, "3").then((res) => {
          const txt = Object.values(res.curatetext).slice(0, 3).join(" ");
          setCurate(txt);
        });
      });
  };

  useEffect(getNewsData, [newsId]);

  const getRandomThumbnail = () => {
    const thumbnailList = [
      thumbnail,
      thumbnail2,
      thumbnail3,
      thumbnail4,
      thumbnail5,
    ];
    if (newsId) {
      const idx = Math.floor(Math.random() * 4);
      return thumbnailList[idx];
    }
    return thumbnailList[0];
  };

  const relatedDartNewsClick = (id) => {
    window.location.replace(`/dart-news/${id}`);
  };
  const moveToStock = () => navigate(`/stock/${news.stockcode}`);

  const notify = (msg, type) => {
    if (type === "success") return toast.success(msg);
    else if (type === "error") return toast.error(msg);
    else return toast(msg);
  };

  const bookmarkCheck = () => {
    checkScrapAPI(newsId).then((res) => {
      if (res.length > 0) {
        setScrap(true);
        setScrapIdx(res[0].scrapeidx);
      } else {
        setScrap(false);
      }
    });
  };
  useEffect(bookmarkCheck, [scrap]);

  const bookmarkClick = () => {
    if (scrap === true) {
      deleteScrapNewsAPI(scrapIdx).then(() => {
        setScrap(false);
        notify("스크랩 목록에서 삭제했습니다", "success");
      });
    } else if (scrap === false) {
      addScrapAPI(news.newsid, "D").then(() => {
        setScrap(true);
        notify("스크랩 목록에 저장했습니다", "success");
      });
    } else {
      notify("로그인이 필요합니다.", "error");
    }
  };

  const handleClick = () => (e) => {
    setAnchorEl(e.currentTarget);
    setOpen((prev) => !prev);
  };

  const handleClose = () => setOpen(false);

  const mailShare = () => {
    const body = `
        [뉴스썸]에서 공유한 뉴스입니다.%0D%0A
        %0D%0A
        뉴스 제목 : ${news.subject}%0D%0A
        뉴스 링크 : https://dev-www.newssalad.com${window.location.pathname}%0D%0A
        원문 링크 : ${news.url}%0D%0A
        %0D%0A
        `;
    setSubject("[뉴스썸] " + news.subject);
    setMailBody(body);
  };

  const kakaoShare = (news) => {
    window.Kakao.Share.sendCustom({
      templateId: 92864,
      templateArgs: {
        img: news.imgsrc,
        newsID: news.newsid,
        title: news.subject,
        description: news.summary,
      },
    });
  };

  const checkSubscribe = () => {
    if (!!news) {
      checkMycorpAPI(news.stockcode).then((res) => {
        setIsSubscribe(res);
      });
    }
  };

  useEffect(checkSubscribe, [news]);

  const subscribeBtnClick = (stockcode, stockname) => {
    if (isSubscribe === true) {
      delMycorpAPI(stockcode).then(() => {
        notify("마이기업 삭제가\n 완료 되었습니다.", "success");
        setIsSubscribe(false);
      });
    } else if (isSubscribe === false) {
      addMycorpAPI(stockcode).then((res) => {
        if (res) {
          setIsSubscribe(true);
          notify(
            stockname +
              " 이/가 마이기업으로\n등록 되었습니다.\nAI 콴의 다양한 뉴스 분석 콘텐츠를\n 확인해보세요!",
            "success"
          );
        } else {
          notify(stockname + " 이/가 이미 존재합니다!", "error");
        }
      });
    } else {
      notify("로그인이 필요합니다.", "error");
    }
  };

  useEffect(checkSubscribe, [isSubscribe]);

  return (
    <div className="singlenews container">
      <div
        className="inner_container"
        style={{
          display: "flex",
          marginTop: "0",
          marginBottom: "0",
          minHeight: "743px",
        }}
      >
        <div className="dart_container">
          {news && (
            <>
              <div>
                <span
                  style={{
                    fontSize: "13px",
                    letterSpacing: "-0.65px",
                    color: "#555",
                  }}
                >
                  뉴스썸 · {news.registdate}
                </span>
                <h1>{news.subject}</h1>
                <p className="content">{news.summary}</p>
                <a
                  className="hyperlink"
                  href={news.url}
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  {news.url}
                </a>
                <div className="btn_container">
                  <Checkbox
                    {...label}
                    className="bookmark_btn"
                    sx={{ color: "#999999" }}
                    onClick={bookmarkClick}
                    checked={scrap}
                    icon={<BookmarkBorderOutlinedIcon />}
                    checkedIcon={<BookmarkIcon />}
                  />
                  <Toaster containerStyle={{ top: 140 }} />
                  <Button
                    sx={{
                      border: "1px solid rgba(0, 40, 100, 0.12)",
                      borderRadius: "50%",
                      minWidth: 0,
                      width: "44px",
                      color: "#999999",
                      height: "44px",
                      "&:focus": { border: "1px solid rgba(0, 40, 100, 0.12)" },
                    }}
                    className={styles.share_btn}
                    onClick={handleClick("bottom-start")}
                  >
                    <IosShareIcon />
                  </Button>
                  <Popper
                    open={open}
                    anchorEl={anchorEl}
                    placement="bottom-start"
                    transition
                  >
                    {({ TransitionProps }) => (
                      <Fade {...TransitionProps}>
                        <Paper className={styles.modal}>
                          <ClearRoundedIcon
                            className={styles.close}
                            onClick={handleClose}
                          />
                          <ul className={styles.icon_container}>
                            <li>
                              <a
                                href={`mailto:?to=&Subject=${subject}&body=${mailBody}`}
                              >
                                <img
                                  src={mail}
                                  alt="kakao"
                                  onClick={mailShare}
                                />
                              </a>
                            </li>
                            <li className={styles.icon_name}>메일</li>
                          </ul>
                          <ul className={styles.icon_container}>
                            <li>
                              <img
                                src={kakao}
                                alt="kakao"
                                onClick={() => kakaoShare(news)}
                              />
                            </li>
                            <li className={styles.icon_name}>카카오</li>
                          </ul>
                          <div className={styles.url}>
                            <input value={news.url} />
                            <button
                              onClick={() => {
                                pasteURL();
                                navigator.clipboard.writeText(
                                  window.location.href
                                );
                              }}
                            >
                              URL 복사
                            </button>
                          </div>
                        </Paper>
                      </Fade>
                    )}
                  </Popper>
                </div>
              </div>

              <div className="stock_info_container">
                <div>
                  <p>
                    <span>
                      {news.stockname} {news.stockquotes.toLocaleString()}
                    </span>
                    <span
                      style={{
                        color:
                          news.gappercent === 0
                            ? "#000"
                            : news.gappercent > 0
                            ? "#e1050c"
                            : "#3d6ae6",
                        marginLeft: "4px",
                      }}
                    >
                      {news.gappercent === 0
                        ? "-"
                        : news.gappercent > 0
                        ? "▲"
                        : "▼"}
                      {news.gappercent}%
                    </span>
                    <Button
                      variant="outlined"
                      startIcon={<AddIcon />}
                      sx={{
                        height: "28px",
                        borderRadius: "23px",
                        padding: "8px 6px",
                        marginLeft: "11px",
                        border: isSubscribe ? "none" : "solid 1px #e63d44",
                        color: isSubscribe ? "#fff" : "#e63d44",
                        backgroundColor: isSubscribe ? "#e63d44" : "#fff",
                        "&:hover": {
                          border: isSubscribe ? "none" : "solid 1px #e63d44",
                          color: isSubscribe ? "#fff" : "#e63d44",
                          backgroundColor: isSubscribe ? "#e63d44" : "#fff",
                        },
                        "&:focus": {
                          border: isSubscribe ? "none" : "solid 1px #e63d44",
                          color: isSubscribe ? "#fff" : "#e63d44",
                          backgroundColor: isSubscribe ? "#e63d44" : "#fff",
                        },
                        "& span": { marginRight: 0 },
                      }}
                      onClick={() =>
                        subscribeBtnClick(news.stockcode, news.stockname)
                      }
                    >
                      <span>구독</span>
                    </Button>
                  </p>
                  <p className="curate_msg">{curate}</p>
                </div>
                <Button
                  variant="outlined"
                  endIcon={<ArrowForwardIcon sx={{ color: "#999" }} />}
                  className="move__stock_btn"
                  onClick={moveToStock}
                  sx={{
                    right: 0,
                    height: "46px",
                    borderRadius: "23px",
                    color: "#222",
                    "&:hover": {
                      border: "solid 1px #eee",
                      backgroundColor: "#f7f7f9",
                    },
                    "&:focus": {
                      border: "solid 1px #eee",
                    },
                  }}
                >
                  <span className="hide_txt">종목 보러가기</span>
                </Button>
              </div>
            </>
          )}
        </div>

        <div className="related_news_container">
          {news && (
            <h2 style={{ marginBottom: "24px", fontSize: "17px" }}>
              <span style={{ color: "#3d6ae6" }}>‘{news.stockname}’</span> 관련
              다른 공시뉴스 확인하기
            </h2>
          )}
          {corpDartNewsList &&
            corpDartNewsList.map((dart, idx) => (
              <div
                className="related_dart_news_card"
                key={dart.newsid}
                onClick={() => relatedDartNewsClick(dart.newsid)}
              >
                <RelatedNews title={dart.subject} src={getRandomThumbnail()} />
                {idx !== corpDartNewsList.length - 1 && (
                  <div
                    className="divider"
                    style={{
                      margin: "12px 0",
                      borderColor: "#eeeeee",
                      padding: "0",
                    }}
                  />
                )}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default DartSingleNews;
